import { Box, Container, Typography } from "@material-ui/core";
import Loading from "components/Loading";
import { RootState } from "config/store";
import { round } from "lodash";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getOrderById } from "shared/network/order.api";
import { ItemPriceHistory, ItemTaxHistory, Order } from "shared/types";
import { OrderFormValues } from "../components/OrderForm";

const SellingPricePage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const orderId = query.get("id");
  const { tenant } = useSelector((state: RootState) => state.authentication.selectedRelTenant);
  const form = useForm<OrderFormValues>({ mode: "onBlur" });
  const selectedCurrency = form.watch("order.currency");
  const [order, setOrder] = useState<Order | null>(null);

  const { isLoading } = useQuery(
    ["sellingOrderQuery", orderId],
    async () => {
      if (orderId) {
        const { data } = await getOrderById(orderId, tenant?.id);
        return data?.item;
      }
      return Promise.reject();
    },
    {
      refetchInterval: 2000,
      enabled: !!orderId,
      onSuccess: data => {
        setOrder(data);

        form.setValue("relOrderItem", data?.relOrderItems);
        form.setValue("order", data as any);
      },
    },
  );

  function getTotal() {
    let relItems = form.watch("relOrderItem");
    let total = 0;
    relItems?.forEach(rel => {
      const priceHistory = rel.item.itemPriceHistories.find(
        (price: ItemPriceHistory) => price.isActive && selectedCurrency.id === price?.currency?.id,
      );
      const price = priceHistory?.price ? Number(priceHistory?.price) : 0;
      const tax =
        (rel.item?.itemTaxHistories?.find((tax: ItemTaxHistory) => tax.isActive)?.tax?.percent ||
          0) / 100 || 0;
      const grossPrice = round(price * (1 + tax), 2);

      total += grossPrice * rel.quantity;
    });
    return total;
  }

  const totalPrice = getTotal();

  return (
    <Container maxWidth="lg">
      <Loading open={isLoading} />
      <Box
        pb={2}
        style={{
          display: "flex", // Flexbox használata
          justifyContent: "center", // Vízszintes középre igazítás
          alignItems: "center", // Függőleges középre igazítás
          height: "100vh", // A teljes ablak magasságának kitöltése
        }}
      >
        <Box>
          <Typography
            style={{
              fontWeight: "bold",
              fontSize: "5vw", // A betűméret az ablak szélességének 5%-a
              width: "100%", // Teljes szélesség
              textAlign: "center", // Középre igazítás
              overflow: "hidden", // Ha túlcsordul, elrejti
              whiteSpace: "nowrap", // Egy sorban tartja a szöveget
            }}
          >
            {t("order.formValues.fullGrossPrice")}
            {": "}
          </Typography>
          <Typography
            style={{
              fontWeight: "bold",
              fontSize: "10vw", // A betűméret az ablak szélességének 10%-a
              width: "100%", // Teljes szélesség
              textAlign: "center", // Középre igazítás
              overflow: "hidden", // Ha túlcsordul, elrejti
              whiteSpace: "nowrap", // Egy sorban tartja a szöveget
            }}
          >
            {(order?.currency?.prefix ? order?.currency.prefix + " " : "") +
              t("common:number", { num: totalPrice }) +
              (order?.currency?.postfix ? " " + order?.currency.postfix : "")}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default SellingPricePage;
